import { cartActions } from 'actions';
import { Dispatch } from 'redux';
import { PlantAddress } from 'types';
import { OrderInputWithSFFlag } from 'types/parts';
import { CartPurchasable, CartState } from 'types/parts/cart';

export const convertPlantAddressToString = (plant: PlantAddress): string => {
  const plantAddressParts = [
    plant.addressLine1,
    plant.addressLine2,
    plant.city,
    plant.state,
    plant.zipCode
  ];

  const plantAddressString = plantAddressParts
    .filter((part) => part && part.trim() !== '')
    .join(', ');
  return plantAddressString;
};

export type CartPriceType = 'mix' | 'none-price' | 'price' | 'nill';

export const removeOrderedItem = (products: CartPurchasable[], dispatch: Dispatch): void => {
  
  products.forEach((item) => {
    dispatch({
      type: cartActions.REMOVE_FROM_CART,
      item: item.item,
      quantity: item.quantity,
      groupId: item.groupId
    });
  });

};

export const getSelectedCartState = (
  cart: CartState,
  selectedPriceType?: CartPriceType,
  selected?: boolean,
  placePronetOrder: boolean = false
): CartState => {
  let filteredItems: CartPurchasable[] = [];
  let nonePriceItems: CartPurchasable[] = [];
  if (selectedPriceType && cart) {
    switch (selectedPriceType) {
      case 'none-price':
        filteredItems = cart.items.filter(
          (product) => product.item.isPriceMissing && product.selected
        );
        // if no items are selected then show all none-price items
        if (filteredItems.length === 0) {
          filteredItems = cart.items.filter((product) => product.item.isPriceMissing);
        }
        nonePriceItems = cart.items.filter((product) => product.item.isPriceMissing  && product.selected);
        if (nonePriceItems.length === 0) {
          nonePriceItems = cart.items.filter((product) => product.item.isPriceMissing);
        }
        break;
      case 'price':
        filteredItems = cart.items.filter(
          (product) => !product.item.isPriceMissing && product.selected
        );
        // if no items are selected then show all price items
        if (filteredItems.length === 0) {
          filteredItems = cart.items.filter((product) => !product.item.isPriceMissing);
        }
        break;
      case 'mix':
        // check if no item is selected
        const selectedItems = cart.items.filter((product) => product.selected);
        const hasSelectedItems = selectedItems.length > 0;
        if (hasSelectedItems) {
          filteredItems = selectedItems.filter((product) => !product.item.isPriceMissing);
          nonePriceItems = selectedItems.filter((product) => product.item.isPriceMissing);
        } else {
          filteredItems = cart.items.filter((product) => !product.item.isPriceMissing);
          nonePriceItems = cart.items.filter((product) => product.item.isPriceMissing);
        }

        break;
      default:
        // If selectedPriceType is neither "none-price" nor "price", return all items
        filteredItems = cart.items;
    }
  } else {
    // If no selectedPriceType is provided, return the original cart state
    filteredItems = selected ? cart.items.filter((product) => product.selected) : cart.items;
  }

  const newCartState = { ...cart, items: filteredItems, nonePriceItems };
  return newCartState;

};

export const OrderBtnText = (selectedCartPriceType: CartPriceType): string => {
  return selectedCartPriceType === 'none-price' ? 'request_quote' : 'place_order';
};

export function checkCartItemsPrice(cart: CartState): CartPriceType {
  const cartPriceState = {
    priceItem: false,
    nonPriceItem: false
  };
  cart.items.forEach((product) => {
    const { item } = product;
    if (!item.isPriceMissing) {
      cartPriceState.priceItem = true;
    } else {
      cartPriceState.nonPriceItem = true;
    }
  });

  if (cart.nonePriceItems && cart.nonePriceItems.length > 0) {
    cartPriceState.nonPriceItem = true;
  }

  if (cartPriceState.priceItem && cartPriceState.nonPriceItem) {
    return 'mix';
  } else if (cartPriceState.nonPriceItem) {
    return 'none-price';
  } else {
    return 'price';
  }
}

export function checkCartPriceTypeBySelection(cart: CartState): CartPriceType {
  // check the cart state and return the price type based on the selected items
  const cartPriceState = {
    priceItem: false,
    nonPriceItem: false
  };
  cart.items.forEach((product) => {
    const { item, selected } = product;
    if (selected) {
      if (!item.isPriceMissing) {
        cartPriceState.priceItem = true;
      } else {
        cartPriceState.nonPriceItem = true;
      }
    }
  });

  if (cartPriceState.priceItem && cartPriceState.nonPriceItem) {
    return 'mix';
  } else if (cartPriceState.nonPriceItem) {
    return 'none-price';
  } else if (cartPriceState.priceItem) {
    return 'price';
  } else {
    return 'nill';
  }
}
